@if (isVisible()) {
  <div (click)="openLocationFlow()" class="location-info-box border-radius-4 or-cursor-pointer">
    <span class="location-info-box__icon"></span>

    <div class="location-info-box__body">
      <div class="or-head-sm">{{ title() }}</div>
      <div class="or-text-sm or-color-secondary-2 or-mt-4-px">{{ subtitle }}</div>
    </div>
  </div>
}
